// src/components/notesdefrais/NoteDeFraisHubMobile.js - VERSION COMPLÈTE CORRIGÉE

import React, { useState, useEffect } from 'react';
import noteDeFraisStorage from '../../services/noteDeFraisStorage';
import cloneManager from '../../services/cloneManager';
import apiService from '../../services/apiService';

const CATEGORIES = {
  repas: '🍽️ Repas',
  deplacement_vehicule: '🚗 Déplacement',
  peage: '🛣️ Péage',
  hotel: '🏨 Hôtel',
  transport_public: '🚆 Transport',
  parking: '🅿️ Parking',
  fournitures: '📦 Fournitures',
  divers: '📋 Divers'
};

const STATUTS = {
  brouillon: { label: 'Brouillon', color: '#94a3b8' },
  soumise: { label: 'Soumise', color: '#3b82f6' },
  validee: { label: 'Validée', color: '#10b981' },
  refusee: { label: 'Refusée', color: '#ef4444' },
  remboursee: { label: 'Remboursée', color: '#8b5cf6' }
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #d1fae5, #a7f3d0)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
  },
  headerTitle: {
    fontSize: '20px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  calculatorBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '20px',
    touchAction: 'manipulation',
    WebkitTapHighlightColor: 'transparent'
  },
  content: {
    padding: '20px'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
    marginBottom: '20px'
  },
  statCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    textAlign: 'center'
  },
  statValue: {
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '4px'
  },
  statLabel: {
    fontSize: '11px',
    color: '#64748b',
    fontWeight: '600'
  },
  filterTabs: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
    overflowX: 'auto',
    padding: '4px'
  },
  tab: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: '2px solid #e2e8f0',
    background: 'white',
    fontSize: '13px',
    fontWeight: '600',
    color: '#64748b',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  },
  tabActive: {
    background: '#10b981',
    borderColor: '#10b981',
    color: 'white'
  },
  noteCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    cursor: 'pointer'
  },
  noteHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px'
  },
  noteDate: {
    fontSize: '13px',
    color: '#64748b',
    fontWeight: '600'
  },
  noteMontant: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#0f172a'
  },
  noteCategorie: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#059669',
    marginBottom: '8px'
  },
  noteDescription: {
    fontSize: '14px',
    color: '#475569',
    marginBottom: '12px'
  },
  noteFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  statutBadge: {
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: '700',
    color: 'white'
  },
  ticketBadge: {
    fontSize: '11px',
    color: '#64748b'
  },
  addButton: {
    position: 'fixed',
    bottom: '80px',
    right: '20px',
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    color: 'white',
    fontSize: '28px',
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(16, 185, 129, 0.4)',
    zIndex: 50
  },
  syncButton: {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    right: '20px',
    padding: '16px',
    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(59, 130, 246, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#94a3b8'
  },
  recapBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: 'white',
    borderRadius: '12px',
    padding: '12px 14px',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  recapLabel: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#059669',
    flex: '1 1 auto',
    minWidth: '90px'
  },
  recapMonthInput: {
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    padding: '6px 8px',
    fontSize: '13px',
    color: '#0f172a',
    fontWeight: '600'
  },
  recapButton: {
    background: 'linear-gradient(135deg, #0d9488, #0f766e)',
    border: 'none',
    color: 'white',
    padding: '8px 14px',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '13px',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  }
};

function NoteDeFraisHubMobile({ onNavigate, onBack }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [activeFilter, setActiveFilter] = useState('tous');
  const [unsyncedCount, setUnsyncedCount] = useState(0);
  const [recapMonth, setRecapMonth] = useState(new Date().toISOString().slice(0, 7));
  const [downloadingRecap, setDownloadingRecap] = useState(false);

  useEffect(() => {
    loadNotes();
  }, []);

  const handleDownloadRecap = async () => {
    setDownloadingRecap(true);
    try {
      const result = await apiService.downloadRecapMensuelPdf(recapMonth);
      if (!result.success) {
        alert('❌ Impossible de générer le récapitulatif : ' + (result.error || 'erreur inconnue'));
        return;
      }
      const url = URL.createObjectURL(result.blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Notes_de_frais_${recapMonth}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (error) {
      console.error('❌ Erreur téléchargement récapitulatif:', error);
      alert('❌ Erreur téléchargement récapitulatif: ' + error.message);
    } finally {
      setDownloadingRecap(false);
    }
  };

  const loadNotes = async () => {
    setLoading(true);
    try {
      const clone = cloneManager.getClone();
      const inspecteurId = clone?.inspecteur?.id;
      
      const allNotes = await noteDeFraisStorage.getAllNotes(inspecteurId);
      setNotes(allNotes);
      
      const unsynced = allNotes.filter(n => !n.synced).length;
      setUnsyncedCount(unsynced);
      
      console.log('✅ Notes chargées:', allNotes.length, '- Non sync:', unsynced);
    } catch (error) {
      console.error('❌ Erreur chargement notes:', error);
      alert('❌ Erreur chargement notes: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      const token = cloneManager.getToken();
      
      if (!token) {
        alert('❌ Vous devez être connecté pour synchroniser.');
        return;
      }
      
      const result = await noteDeFraisStorage.syncToBase44();
      
      if (result.success) {
        await loadNotes();
        
        let message = `✅ ${result.synced} note(s) synchronisée(s)`;
        if (result.failed > 0) {
          message += `\n⚠️ ${result.failed} échec(s)`;
        }
        
        alert(message);
      } else {
        alert('❌ Erreur de synchronisation: ' + result.error);
      }
    } catch (error) {
      console.error('❌ Erreur sync:', error);
      alert('❌ Erreur de synchronisation: ' + error.message);
    } finally {
      setSyncing(false);
    }
  };

  const filteredNotes = activeFilter === 'tous' 
    ? notes 
    : notes.filter(n => n.statut === activeFilter);

  // Calculs stats
  const totalMontant = filteredNotes.reduce((sum, n) => sum + (n.montant || 0), 0);
  const countBrouillon = notes.filter(n => n.statut === 'brouillon').length;
  const countSoumise = notes.filter(n => n.statut === 'soumise').length;

  if (loading) {
    return (
      <div style={{ ...styles.container, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e2e8f0', borderTopColor: '#10b981', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#059669', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>💰 Notes de Frais</h1>
        <div style={{ width: '70px' }}></div>
      </div>

      <div style={styles.content}>
        {/* Stats */}
        <div style={styles.statsGrid}>
          <div style={styles.statCard}>
            <div style={{ ...styles.statValue, color: '#10b981' }}>{totalMontant.toFixed(2)}€</div>
            <div style={styles.statLabel}>TOTAL</div>
          </div>
          <div style={styles.statCard}>
            <div style={{ ...styles.statValue, color: '#94a3b8' }}>{countBrouillon}</div>
            <div style={styles.statLabel}>BROUILLONS</div>
          </div>
          <div style={styles.statCard}>
            <div style={{ ...styles.statValue, color: '#3b82f6' }}>{countSoumise}</div>
            <div style={styles.statLabel}>SOUMISES</div>
          </div>
        </div>

        {/* Récapitulatif mensuel PDF */}
        <div style={styles.recapBar}>
          <span style={styles.recapLabel}>📄 Récap. mensuel</span>
          <input
            type="month"
            style={styles.recapMonthInput}
            value={recapMonth}
            onChange={(e) => setRecapMonth(e.target.value)}
          />
          <button
            style={{ ...styles.recapButton, opacity: downloadingRecap ? 0.7 : 1 }}
            onClick={handleDownloadRecap}
            disabled={downloadingRecap}
          >
            {downloadingRecap ? '⏳...' : 'PDF'}
          </button>
        </div>

        {/* Filtres */}
        <div style={styles.filterTabs}>
          {[
            { key: 'tous', label: 'Toutes' },
            { key: 'brouillon', label: 'Brouillons' },
            { key: 'soumise', label: 'Soumises' },
            { key: 'validee', label: 'Validées' }
          ].map(filter => (
            <button
              key={filter.key}
              style={{
                ...styles.tab,
                ...(activeFilter === filter.key ? styles.tabActive : {})
              }}
              onClick={() => setActiveFilter(filter.key)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Liste notes */}
        {filteredNotes.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📄</div>
            <p style={{ fontSize: '16px', fontWeight: '600' }}>Aucune note de frais</p>
            <p style={{ fontSize: '13px' }}>Appuyez sur + pour en ajouter une</p>
          </div>
        ) : (
          filteredNotes.map(note => (
            <div 
              key={note.id} 
              style={styles.noteCard}
              onClick={() => onNavigate('detail', note.id)}
            >
              <div style={styles.noteHeader}>
                <span style={styles.noteDate}>
                  {new Date(note.date_depense).toLocaleDateString('fr-FR')}
                </span>
                <span style={styles.noteMontant}>{note.montant?.toFixed(2)}€</span>
              </div>
              
              <div style={styles.noteCategorie}>
                {CATEGORIES[note.categorie]}
              </div>
              
              <div style={styles.noteDescription}>
                {note.description}
              </div>
              
              <div style={styles.noteFooter}>
                <span style={{ ...styles.statutBadge, background: STATUTS[note.statut].color }}>
                  {STATUTS[note.statut].label}
                </span>
                <span style={styles.ticketBadge}>
                  {note.ticket_photo_base64 || note.ticket_photo_url ? '📎 Ticket' : ''}
                  {!note.synced && ' • 🔄 Non sync'}
                </span>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Bouton ajouter */}
      <button 
        style={styles.addButton}
        onClick={() => onNavigate('ajouter')}
      >
        +
      </button>

      {/* Bouton sync */}
      {unsyncedCount > 0 && (
        <button 
          style={styles.syncButton}
          onClick={handleSync}
          disabled={syncing}
        >
          {syncing ? (
            <>
              <div style={{ width: '20px', height: '20px', border: '3px solid white', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
              Synchronisation...
            </>
          ) : (
            <>
              🔄 Synchroniser {unsyncedCount} note{unsyncedCount > 1 ? 's' : ''}
            </>
          )}
        </button>
      )}
    </div>
  );
}

export default NoteDeFraisHubMobile;